import request from '@/utils/request';

const state = {
  token: localStorage.getItem('molv_token') || '',
  profile: null,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('molv_token', token);
  },
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  CLEAR(state) {
    state.token = '';
    state.profile = null;
    localStorage.removeItem('molv_token');
  },
};

const actions = {
  async login({ commit }, { email, password }) {
    const res = await request.post('/api/pub/login', { email, password });
    commit('SET_TOKEN', res.data.token);
    commit('SET_PROFILE', res.data.user);
    return res.data;
  },
  async register({ commit }, data) {
    const res = await request.post('/api/pub/register', data);
    commit('SET_TOKEN', res.data.token);
    commit('SET_PROFILE', res.data.user);
    return res.data;
  },
  async fetchProfile({ commit }) {
    const res = await request.get('/api/user/me');
    commit('SET_PROFILE', res.data);
    return res.data;
  },
  logout({ commit }) {
    commit('CLEAR');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
